import { ComponentStyles, Image } from "@mcleod/components";
import { MainMenu } from "./MainMenu";
import { MenuFavorites } from "./MenuFavorites";
import { MenuLauncher } from "./MenuLauncher";
import { MenuTreeNode, MenuTreeNodeProps } from "./MenuTreeNode";

export class MenuTreeNodeLeaf extends MenuTreeNode {
    private favoriteImage: Image;
    constructor(mainMenu: MainMenu, props?: Partial<MenuTreeNodeProps>) {
        super({
            color: "component.palette.menu.secondaryColor",
            ...props
        });
        this.label.setProps({themeKey: "menu.leafNodeLabel"});

        this._element.style.marginLeft = "";
        this.setClassIncluded(ComponentStyles.hoverShade);
        this.createFavoriteButton();

        const menuLauncher = new MenuLauncher(mainMenu);
        this.contextMenuItems = () => [
            { text: "Open in New Tab", onClick: () => menuLauncher.openPage(this.menuItem, true, true) },
            { text: "Open in New Window", onClick: () => menuLauncher.openPage(this.menuItem, true, false) }
        ]

        this.addClickListener(menuLauncher.openPageOnClick(this.menuItem, false));
    }

    private createFavoriteButton() {
        this.favoriteImage = new Image({
            themeKey: "menu.favoriteImage",
            stroke: "caution.dark",
            onClick: () => this.favoriteOnClick()
        });

        this.addMouseEnterListener(() => {
            this.syncFavoriteButton();
            this.favoriteImage.style.visibility = "visible";
        });

        this.addMouseLeaveListener(() => {
            this.favoriteImage.style.visibility = "hidden";
        });
        this.panel.add(this.favoriteImage);
        this.hideButtonOnMount();
    }

    private hideButtonOnMount() {
        this.addMountListener(() => {
            this.favoriteImage.style.visibility = "hidden";
            this.addUnmountListener(() => {
                this.favoriteImage.style.visibility = "hidden";
                this.hideButtonOnMount();
            });
        });
    }

    private async favoriteOnClick() {
        this.favoriteImage.enabled = false;
        try {
            await MenuFavorites.addOrRemoveFavorite(this.component, this.menuItem);
        } finally {
            this.syncFavoriteButton();
            this.favoriteImage.enabled = true;
        }
    }

    private syncFavoriteButton() {
        this.favoriteImage.setProps({
            fill: MenuFavorites.isFavorite(this.menuItem) ? "caution.dark" : "transparent",
            marginRight: this.calcFavoriteRightMargin()
        });
    }

    private calcFavoriteRightMargin(): number {
        const treeElement = this.getTree()?._element;
        const scrollbarWidth = treeElement ? (treeElement.offsetWidth - treeElement.clientWidth) : 0;
        return 12 - scrollbarWidth;
    }
}
